import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import qs from "qs";

export default function ShopTop() {
  const navigate = useNavigate();
  const location = useLocation();

  const [search, setSearch] = useState("");
  const [dimension, setDimension] = useState("");
  const [side, setSide] = useState("");
  const [value, setValue] = useState("");

  useEffect(() => {
    const params = qs.parse(location.search, { ignoreQueryPrefix: true });
    if (params.search) setSearch(params.search as string);
    if (params.dimension) setDimension(params.dimension as string);
    if (params.side) setSide(params.side as string);
    if (params.value) setValue(params.value as string);
  }, [location.search]);

  const handleFilter = () => {
    if (!dimension || !side || !value) return;
    const query = qs.stringify(
      { search, dimension, side, value },
      { addQueryPrefix: true }
    );
    navigate(`/products${query}`);
  };

  const handleClear = () => {
    setSearch("");
    setDimension("");
    setSide("");
    setValue("");
    navigate("/products");
  };

  const handleSearch = (e: any) => {
    setSearch(e.target.value);
    const query = qs.stringify(
      { search: e.target.value, dimension, side, value },
      { addQueryPrefix: true }
    );
    navigate(`/products${query}`);
  };

  return (
    <div className="ec-pro-list-top d-flex row">
      <div className="col-md-3 ec-grid-list">
        <div className="ec-input-inner">
          <input
            type="text"
            placeholder="Search"
            className="ec-input"
            name="name"
            style={{
              background: "white",
              border: "0",
              height: "34px",
            }}
            value={search}
            onChange={handleSearch}
          />
        </div>
      </div>

      <div className="col-md-9 ec-sort-select">
        <div className="ec-select-inner mr-1">
          <select
            name="dimension-select"
            id="dimension-select"
            value={dimension}
            onChange={(e) => setDimension(e.target.value)}
          >
            <option value="" disabled>
              Dimension
            </option>
            <option value="inch">Inch</option>
            <option value="cm">CM</option>
          </select>
        </div>
        <div className="ec-select-inner mr-1">
          <select
            name="side-select"
            id="side-select"
            value={side}
            onChange={(e) => setSide(e.target.value)}
          >
            <option value="" disabled>
              Side
            </option>
            <option value="length">Length</option>
            <option value="width">Width</option>
            <option value="height">Height</option>
          </select>
        </div>
        <div className="ec-input-inner mr-1">
          <input
            type="text"
            placeholder="Value"
            className="ec-input"
            name="value"
            style={{
              background: "white",
              border: "0",
              height: "34px",
            }}
            value={value}
            onChange={(e) => setValue(e.target.value)}
          />
        </div>
        <div>
          <button className="btn btn-list" onClick={handleFilter}>
            Filter
          </button>
          <button className="btn btn-grid active" onClick={handleClear}>
            Clear
          </button>
        </div>
      </div>
    </div>
  );
}
